__turbopack_context__.v({
  "columns": "_7RviTq_columns",
  "columnswrapper": "_7RviTq_columnswrapper",
});
